import opera from "images/b2c/opera.png";
import chrome from "images/b2c/chrome.png";
import firefox from "images/b2c/firefox.png";

export const browserList = [
  { imageUrl: chrome, name: "Chrome", url: "https://www.google.com/chrome" },
  { imageUrl: firefox, name: "Firefox", url: "https://www.mozilla.org/en-US/firefox/new" },
  { imageUrl: opera, name: "Opera", url: "https://www.opera.com/download" }
];
